var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature"},[_c('h5',{staticClass:"feature__title"},[_vm._t("title")],2),(_vm.$slots.description)?_c('p',{staticClass:"feature__description"},[_vm._t("description")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }